<template>
<div class="page page_hezuo">
    <div class="form_wrap">
        <div class="item">
            <div class="title">房间名称</div>
            <div class="name">
                <van-field v-model="name" placeholder="请输入房间名称..." />
            </div>
        </div>
        <div class="item flex" @click="roomPicker=true">
            <div class="item_l">
                <div class="title">房间类型</div>
                <van-field v-model="type" placeholder="请选择房间类型..." />
            </div>
            <div class="item_r" @click="roomPicker=true">选择</div>
        </div>
        <div class="item">
            <div class="title">开放时间</div>
            <div class="name">
                <van-field v-model="stratTime" placeholder="请填写开放时间..." readonly="" @click="selectStartTime(0)" />
            </div>
        </div>
        <div class="item">
            <div class="title">关闭时间</div>
            <div class="name">
                <van-field v-model="endTime" placeholder="请填写关闭时间..." readonly="" @click="selectStartTime(1)" />
            </div>
        </div>
        <div class="item">
            <div class="title">添加封面</div>
            <div class="upload_images">
                <!-- 示例图片 -->
                <div class="img_box">
                    <div class="img_bu">
                        <img class="image" :src="imageUrl+cover" />
                    </div>
                </div>
                <van-uploader :after-read="onCoverRead" accept class="icon-add" ref="cover">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
            <div class="tu_tip">图片类型jpg/jpeg/gif/png,345*150,大小不超过2M</div>
        </div>
        <div class="item">
            <div class="title">房间描述</div>
            <div class="name">
                <van-field v-model="desc" placeholder="请填写房间描述..." />
            </div>
        </div>
        <div class="item">
            <div class="title">房间公告</div>
            <div class="name">
                <van-field v-model="notice" placeholder="请填写房间公告..." />
            </div>
        </div>
        <!-- 协议 -->
        <div class="xieyi">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(9)">“用户协议和隐私条款”</span></div>
        </div>
        <!-- 入驻 -->
        <div class="big_btn" @click="applyZhibo">开通直播</div>
        <!-- 类型弹层 -->
        <van-popup v-model="roomPicker" position="bottom">
            <van-picker show-toolbar :columns="typeList" value-key="name" @cancel="roomPicker = false" @confirm="confrimType"/>
        </van-popup>
        <!-- 时间弹层 -->
        <van-popup v-model="timePicker" position="bottom">
            <van-datetime-picker v-model="currentDate" type="datetime" title="选择时间" :min-date="minDate" @confirm="confrimTime"  @cancel="timePicker = false"/>
        </van-popup>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
// Vue.prototype.Aliplayer = Aliplayer
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
            name: '',
            type: '',
            roomPicker: false,
            stratTime: '',
            endTime: '',
            cover: null,
            desc: '',
            notice: '',
            checked_xieyi: true,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            typeList: [],
            selectType: null,
            timePicker: false,
            timeType: 0,
            currentDate: new Date(),
            minDate: new Date()
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '申请直播',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
                var memberParams = {
                    data: {
                        notCallLogin: 1,
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                        } else {
                            this.token = "";
                        }
                    }
                );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token;
        }
        this.getLivingType()
    },
    mounted: function () {

    },
    methods: {
        getLivingType() {
            var params = {
            }
            this.$api.living.typeList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    for (let i = 0; i < list.length; i++) {
                        var living = list[i];
                        living.name = living.title
                        list[i] = living
                    }
                    this.typeList = list
                    console.log(this.typeList)
                } 
            })
        },
        // 选择分类
        confrimType(e) {
            this.selectType = e
            this.roomPicker = false
            this.type = this.selectType.name
            console.log(e)
        },
        // 上传封面
        onCoverRead(file) {
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    console.log("上传成功");
                    console.log(res);
                    this.cover = res.result.url;
                }
            });
        },
        // 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
        goSinglePage(id) {
            this.$router.push({
                path: '/single/page',
                query: {
                    id: id
                }
            })
        },
        // 选择时间
        selectStartTime(type) {
            this.timePicker = true
            this.timeType = type
        },
        // 确认选择时间
        confrimTime(value) {
            if (this.timeType == 0) {
                this.stratTime = this.formatDate(value)
            } else if (this.timeType == 1) {
                this.endTime = this.formatDate(value)
            }
            this.timePicker = false
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
			var day = date.getDate().toString();
			var hour = date.getHours().toString()
			var minutes = date.getMinutes().toString()
			var seconds = date.getSeconds().toString()
            if (month.length == 1) {
                month = '0' + month;
            }
            if (day.length == 1) {
                day = '0' + day;
			}
			if (hour.length == 1) {
                hour = '0' + hour;
			}
			if (minutes.length == 1) {
                minutes = '0' + minutes;
			}
			if (seconds.length == 1) {
                seconds = '0' + seconds;
			}
            return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
        },
        // 提交
        applyZhibo() {
            if (this.name == null || this.name == undefined || this.name == '') {
                this.$toast('请输入房间名称')
                return
            }
            if (this.selectType == null || this.name == undefined ) {
                this.$toast('请选择房间类型')
                return
            }
            if (this.stratTime == null || this.stratTime == undefined || this.stratTime == '') {
                this.$toast('请选择开放时间')
                return
            }
            if (this.endTime == null || this.endTime == undefined || this.endTime == '') {
                this.$toast('请选择关闭时间')
                return
            }
            if (this.cover == null || this.cover == undefined || this.cover == '') {
                this.$toast('请上传封面图片')
                return
            }
            if (this.desc == null || this.desc == undefined || this.desc == '') {
                this.$toast('请输入房间描述')
                return
            }
            if (this.notice == null || this.notice == undefined || this.notice == '') {
                this.$toast('请输入房间公告')
                return
            }
            var params = {
                token: this.token,
                title: this.name,
                open_room: this.stratTime,
                close_room: this.endTime,
                describe: this.desc,
                notice: this.notice,
                type_id: this.selectType.id,
                thumb: this.cover
            }
            this.$api.living.applyLiving(params).then(res => {
                if (res.code == 200) {
                    this.$toast('申请成功')
                    if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
                        //返回上级页面
                        var params = {'data':{}}
                        this.$bridge.callhandler('sdjy://public/back', params, (data) => {
                        })
                    } else {
                        this.$router.back()
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
